import bindScroll from 'helpers/bindScroll';
import landscapeCarousel from 'components/landscapeCarousel';
import portraitCarousel from 'components/portraitCarousel';
import onNowCarousel from 'carousels/onNowCarousel';
import scheduleCarousel from 'carousels/scheduleCarousel';
import brandCarousel from 'carousels/brandCarousel';
import carouselWrapperTpl from 'templates/carousels/wrapper.tpl';
import { Tracking } from 'shared/fathomTracking';
import { getLocale } from 'services/LocalizationService';
import urlHelper from 'helpers/UrlHelper';

const HOME_SHOW_GROUP = 'homeShowGroup';
const SCHEDULE_CAROUSEL = 'schedule';
const ONNOW_CAROUSEL = 'onnow';
const BRAND_CAROUSEL = 'brands';

export default function hpConfigurator() {
    let objs = [];
    let userState = CBS.Registry.user_auth ? 'rg' : 'an';
    let _regionPrefix = CBS.Registry.region.prefix;
    
    // START A/B TEST PLGRWEB-337 : My-List-Reordering on Homepage
    const MY_LIST = 'My List';
    const SORT_MY_LIST_REORDER_NEW_CONTENT_VARIANT = 'reorder_for_new_content';
    const SORT_PINNED_RECENTLY_ADDED = 'pinned_recently_added';
    
    const portraitCarouselFunc = (element, options)=>{
        portraitCarousel({
            parentContainer: element,
            options: options
        });
    }
    // END A/B TEST PLGRWEB-337 : My-List-Reordering on Homepage

    try {
        $.ajax({
            url: `${_regionPrefix}/carousels/homepage/configurator/${userState}/`,
            dataType: 'json',
            type: 'GET',
            cache: false,
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0'
            },
            success: function (resp) {
                if (resp.success) {
                    let topComponents = $('.top-components');
                    let belowTheFoldContainer = $('.bottom-components');
                    let numCounter = 0;

                    Tracking.addNumCarousels(resp.result.length);

                    for (let i = 0; i < resp.result.length; i++) {
                        let carouselData = resp.result[i];
                        let token = carouselData.token;
                        let baseEndpoint =
                            _regionPrefix +
                            '/carousels/homepage/configItems/' +
                            userState +
                            '/' +
                            encodeURIComponent(token) +
                            '/offset/{offset}/limit/{limit}/';
                        /**
                         * Very specific update to 1 HP Showtime Carousel: append bundleStatus for proper caching
                         * TODO: Generalize as necessary where bundleStatus will change a user's carousel response
                         * in terms of status/lock
                         */
                        if (carouselData.model == 'showMovieHybrid' && carouselData.title == 'Showtime Shows & Movies') {
                            baseEndpoint = urlHelper.appendBundleStatus(baseEndpoint);
                        }
                        let wrapper = $(
                            carouselWrapperTpl({
                                recoId: carouselData.recoId,
                                displayId: carouselData.displayId,
                                carouselId: carouselData.carouselId,
                                title: carouselData.title,
                                model: carouselData.model,
                                position: i + 1,
                                // ABTest: homepage descriptions
                                id: formatTitle(carouselData.title),
                                rankModel: carouselData.rankModel
                            })
                        );

                        let carouselElement = wrapper.find('.js-video-carousel');

                        if (carouselData?.model === ONNOW_CAROUSEL) {
                            new onNowCarousel(carouselElement, objs);
                        } else if (carouselData?.model === BRAND_CAROUSEL) {
                            new brandCarousel(carouselElement, objs);
                        } else if (carouselData?.model === SCHEDULE_CAROUSEL) {
                            // initialize schedule carousel element
                            new scheduleCarousel(carouselData, carouselElement, objs);
                        } else if (carouselData?.model === HOME_SHOW_GROUP) {
                            wrapper = $('<section>');
                            wrapper.addClass('home-show-groups-section');

                            objs.push({
                                wrapper: wrapper,
                                init: function () {
                                    $.ajax({
                                        url:
                                            _regionPrefix +
                                            '/carousels/homepage/configItems/' +
                                            userState +
                                            '/' +
                                            encodeURIComponent(token) +
                                            '/offset/0/limit/0/',
                                        dataType: 'json',
                                        type: 'GET',
                                        cache: false,
                                        headers: {
                                            'Cache-Control': 'no-cache',
                                            Pragma: 'no-cache',
                                            Expires: '0'
                                        },
                                        success: function (resp) {
                                            if (resp.success && resp.data && resp.data.length) {
                                                let homeShowGroups = resp.data;
                                                Tracking.addNumCarousels(homeShowGroups.length - 1);

                                                homeShowGroups.forEach((homeShowGroup, index) => {
                                                    let homeshowTitle =
                                                        typeof homeShowGroup.result.title !==
                                                        'undefined'
                                                            ? formatTitle(
                                                                  homeShowGroup.result.title
                                                              )
                                                            : '';
                                                    let carouselContainer = $(
                                                        carouselWrapperTpl({
                                                            recoId: homeShowGroup.result.recoId,
                                                            displayId:
                                                                homeShowGroup.result.displayId,
                                                            carouselId: homeShowGroup.result
                                                                .carouselId
                                                                ? homeShowGroup.result.carouselId
                                                                : '',
                                                            title: homeShowGroup.result.title,
                                                            model: homeShowGroup.result.model,
                                                            // ABTest: homepage descriptions,
                                                            id: homeshowTitle,
                                                            position: numCounter
                                                        })
                                                    );
                                                    wrapper.append(carouselContainer);

                                                    let parentContainer =
                                                        carouselContainer.find(
                                                            '.js-video-carousel'
                                                        );

                                                    portraitCarousel({
                                                        parentContainer: parentContainer,
                                                        options: {
                                                            data: homeShowGroup
                                                        }
                                                    });
                                                });
                                            }
                                        }
                                    });
                                }
                            });
                        } else {
                            objs.push({
                                wrapper: carouselElement,
                                init: function () {
                                    wrapper.on('init', () => {
                                        wrapper.removeClass('hidden');
                                    });

                                    wrapper.on('setPosition', () => {
                                        wrapper.ellipsify();
                                    });

                                    let options = {
                                        endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                                        params: {
                                            slug: wrapper.data('slug'),
                                            sectionId: wrapper.data('sectionid')
                                        }
                                    };

                                    if (carouselData.canEdit) {
                                        options.reloadPoint = options.endPoint;
                                        options.editPoint =
                                            _regionPrefix + '/video/show/delete.json?showId=';
                                        options.trackingParam = 'trackEditKW';
                                    }

                                    if (carouselData.orientation === 'portrait') {
                                        // START A/B TEST PLGRWEB-337 : My-List-Reordering on Homepage
                                        if(carouselData.title === MY_LIST) {
                                            $.getJSON('/abtests/xhr/?tests[0]=_web_test_reordering_my_list_based_on_new_content', (resp)=> {
                                                if (resp.variants._web_test_reordering_my_list_based_on_new_content === SORT_MY_LIST_REORDER_NEW_CONTENT_VARIANT ||
                                                    resp.variants._web_test_reordering_my_list_based_on_new_content === SORT_PINNED_RECENTLY_ADDED) {
                                                    options.useBuffer = false;
                                                }
                                                portraitCarouselFunc(carouselElement, options);
                                            });
                                        }
                                        else {
                                            portraitCarouselFunc(carouselElement, options);
                                        }
                                        // END A/B TEST PLGRWEB-337 : My-List-Reordering on Homepage
                                    } else if (carouselData.orientation === 'landscape') {
                                        landscapeCarousel({
                                            parentContainer: carouselElement,
                                            options: options
                                        });
                                    }
                                }
                            });
                        }

                        // push first element to `topComponents` container for fading effect to work
                        if (i <= 0) {
                            topComponents.append(wrapper);
                        } else {
                            belowTheFoldContainer.append(wrapper);
                        }
                    }

                    if (CBS.Registry.Features.whats_new_hp_carousel == true) {
                        try {
                            let whatsNew = $(
                                carouselWrapperTpl({
                                    recoId: uuid.v4(),
                                    displayId: uuid.v4(),
                                    carouselId: '',
                                    title: getLocale('whats_new'),
                                    // ABTest: homepage descriptions
                                    id: 'whats-new',
                                    position: numCounter + 1
                                })
                            );

                            let whatsNewCarousel = whatsNew.find('.js-video-carousel');

                            objs.push({
                                wrapper: whatsNewCarousel,
                                init: function () {
                                    whatsNewCarousel.on('init', () => {
                                        whatsNewCarousel.removeClass('hidden');
                                    });

                                    whatsNewCarousel.on('setPosition', () => {
                                        whatsNewCarousel.ellipsify();
                                    });

                                    landscapeCarousel({
                                        parentContainer: whatsNewCarousel,
                                        options: {
                                            endPoint:
                                                CBS.Registry.region.prefix +
                                                '/carousels/homepage/whatsnew/offset/{offset}/limit/{limit}/'
                                        }
                                    });
                                }
                            });

                            belowTheFoldContainer.append(whatsNew);
                        } catch (e) {}
                    }

                    new bindScroll(objs);
                    topComponents.removeClass('loading');
                }
            }
        });
    } catch (e) {
        console.log('HP Configurator - ' + e);
    }

    function formatTitle(title) {
        return title.replace(/\'+/g, '').replace(/\s+/g, '-').toLowerCase();
    }
}
